module.exports = __webpack_public_path__ + "static/media/S3N7-4.3e5e6c1b.svg";